import CourseContentLayout from "./CourseContentLayout";

function JuniorCourse(props) {
  return <CourseContentLayout {...props} totalModules={3} />;
}

export default JuniorCourse;